import i18n from 'locale';
import { getPhoneType } from 'services/phone.service';
import { isValidPhone } from 'utils';

// These types come from the Twilio API
// Reference: https://www.twilio.com/docs/lookup/v2-api/line-type-intelligence#type-property-values
const NON_VALID_PHONE_TYPES = ['fixedVoip', 'landline', 'tollFree', 'voicemail'];

export function validateMobilePhone(rule, value, callback) {
  if (!value) {
    return callback();
  }

  if (!isValidPhone(value)) {
    return callback(i18n.t('common:invalid-phone'));
  }

  getPhoneType(value)
    .then(({ valid, type }) => {
      if (valid === true && NON_VALID_PHONE_TYPES.includes(type) === false) {
        callback();
      } else {
        callback('Please enter a valid mobile phone number');
      }
    })
    .catch((error) => {
      callback(error.msg);
    });
}
